var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_173_4235)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 16V9H4.5C4.22386 9 4 8.77614 4 8.5C4 8.22386 4.22386 8 4.5 8H5V5.5C5 3.567 6.567 2 8.5 2H18.5C20.433 2 22 3.567 22 5.5V19.5C22 21.433 20.433 23 18.5 23H8.5C6.567 23 5 21.433 5 19.5V17H4.5C4.22386 17 4 16.7761 4 16.5C4 16.2239 4.22386 16 4.5 16H5ZM6 16H6.49634C6.77248 16 6.99634 16.2239 6.99634 16.5C6.99634 16.7761 6.77248 17 6.49634 17H6V19.5C6 20.8807 7.11929 22 8.5 22H18.5C19.8807 22 21 20.8807 21 19.5V5.5C21 4.11929 19.8807 3 18.5 3H8.5C7.11929 3 6 4.11929 6 5.5V8H6.49634C6.77248 8 6.99634 8.22386 6.99634 8.5C6.99634 8.77614 6.77248 9 6.49634 9H6V16Z",
    fill: "#005383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3325 14.4915C14.9788 14.8077 14.5118 15 14 15C12.8954 15 12 14.1046 12 13C12 11.8954 12.8954 11 14 11C15.1046 11 16 11.8954 16 13C16 13.288 15.9391 13.5617 15.8296 13.8091C15.9906 13.8195 16.1437 13.9076 16.2306 14.0578C16.3787 14.3138 16.6439 14.4472 17.1406 14.4062C17.7256 14.3579 18 13.9614 18 13C18 10.7909 16.2091 9 14 9C11.7909 9 10 10.7909 10 13C10 15.2091 11.7909 17 14 17C14.2761 17 14.5 17.2239 14.5 17.5C14.5 17.7761 14.2761 18 14 18C11.2386 18 9 15.7614 9 13C9 10.2386 11.2386 8 14 8C16.7614 8 19 10.2386 19 13C19 14.4327 18.3956 15.306 17.2229 15.4028C16.347 15.4751 15.7098 15.1547 15.365 14.5585C15.3523 14.5366 15.3415 14.5142 15.3325 14.4915ZM14 14C14.5523 14 15 13.5523 15 13C15 12.4477 14.5523 12 14 12C13.4477 12 13 12.4477 13 13C13 13.5523 13.4477 14 14 14Z",
    fill: "#5CA9D6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_173_4235"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.b69987f02a59281bb053520b0eb72236.svg";
export { ForwardRef as ReactComponent };